// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 * import { ThemeMode } from 'types/config';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = ({ colorOverride }: { colorOverride?: string; }) => {
  const theme = useTheme();
  const fill = colorOverride || theme.palette.text.primary;
  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoIconDark : logoIcon} alt="OTM" width="100" />
     *
     */
    <svg
      width="100%"
      height="100%"
      viewBox={'0 0 35 35'}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <g>
            <path d="M11.5,15.7v9.4c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6v-9.4c0-0.9-0.7-1.6-1.6-1.6C12.2,14,11.5,14.8,11.5,15.7z" />
            <path d="M7,24.9c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V11.7c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6V24.9z" />
            <path d="M20.4,15.7v9.4c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6v-9.4c0-0.9-0.7-1.6-1.6-1.6C21.1,14,20.4,14.8,20.4,15.7z" />
            <path d="M24.8,11.7v13.3c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6V11.7c0-0.9-0.7-1.6-1.6-1.6S24.8,10.8,24.8,11.7z" />
            <path
              d="M28.8,4L28.8,4L28.8,4c-0.2-0.1-0.4-0.2-0.5-0.2c-0.3,0-0.5,0.2-0.5,0.6v1.8l0,0l0,1.4c0,0.3,0.1,0.8,0.6,1.3
				c0,0,0,0,0,0.1l0,0c1.9,2.4,2.9,5.4,2.9,8.4c0,7.6-6.2,13.8-13.8,13.8C10,31.2,3.8,25,3.8,17.4c0-3.1,1-6,2.9-8.4l0,0
				c0,0,0,0,0-0.1c0.5-0.5,0.5-1.1,0.6-1.4V6.2V5.5V4.4c0-0.3-0.2-0.6-0.5-0.6c-0.1,0-0.3,0-0.5,0.1l0,0l0,0C2.3,7.4,0,12.3,0,17.4
				C0,27,7.7,34.9,17.3,35v0h0.2c9.7,0,17.5-7.9,17.5-17.6C35.1,12.3,32.8,7.4,28.8,4z"
            />
            <path
              d="M8.9,6.6c0.1,0,0.3,0,0.4-0.1l0,0l0,0l0,0c1.9-1.4,4-2.3,6.3-2.6v21.2c0,1,0.7,1.7,1.6,1.9v0h0.2c1,0,1.9-0.8,1.9-1.9
				V3.8c2.3,0.3,4.4,1.2,6.3,2.6l0,0l0,0c0,0,0,0,0,0l0,0c0.2,0.1,0.3,0.2,0.4,0.2c0.3,0,0.5-0.2,0.5-0.6l0-2.7
				c0-0.5-0.2-0.9-0.6-1.1c-2.6-1.4-5.5-2.2-8.5-2.2h-0.2v0c-2.9,0-5.7,0.8-8.3,2.2C8.7,2.3,8.5,2.7,8.4,3.2V6
				C8.4,6.3,8.6,6.6,8.9,6.6z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default LogoIcon;
